import React from "react";
import t from "../../../helpers/t";
import FormItem from "../../../components/FormItem";
import "markdown-transform-html/lib/styles/index.css";
import { ADJUSTMENT_HELP_TEXT, HtmlTooltip } from "../../../../utils/HelperOld";

const GeneralUserSettings = (props) => {
  const { onChange, _showPopUp, setting } = props;
  const fontFamilies = [
    { name: "Helvetica" },
    { name: "Arial" },
    { name: "Arial Black" },
    { name: "Verdana" },
    { name: "Tahoma" },
    { name: "Trebuchet MS" },
    { name: "Impact" },
    { name: "Gill Sans" },
    { name: "Times New Roman" },
    { name: "Georgia" },
    { name: "Palatino" },
    { name: "Baskerville" },
    { name: "Andalé Mono" },
    { name: "Courier" },
    { name: "Lucida" },
    { name: "Monaco" },
    { name: "Bradley Hand" },
    { name: "Brush Script MT" },
    { name: "Luminari" },
    { name: "Comic Sans MS" },
  ];
  return (
    <>
      <fieldset className="fieldBox">
        <label className="inb-form__controlLabel legendLabel">
          <HtmlTooltip
            title={
              <React.Fragment>
                {
                  <ADJUSTMENT_HELP_TEXT
                    content={
                      t("Nutzung von Nutzergruppen", null, "capital") +
                      "::" +
                      t("use_memberships_info") +
                      "//"
                    }
                  />
                }
              </React.Fragment>
            }
          >
            <a>
              <i className="inb-ico fi fi-info"> {t("info", null, "capital")}</i>
            </a>
          </HtmlTooltip>
        </label>
        <FormItem
          type="checkbox"
          value={setting.use_memberships}
          id={setting.id}
          name="use_memberships"
          label={t("use memberships")}
          labelStyle={{ minWidth: "230px" }}
          htmlFor={t("use memberships")}
          mediumWidth="12"
          smallWidth="12"
          onChangeHandler={onChange}
        />
      </fieldset>
      <fieldset className="fieldBox">
        <label className="inb-form__controlLabel legendLabel">
          <HtmlTooltip
            title={
              <React.Fragment>
                {
                  <ADJUSTMENT_HELP_TEXT
                    content={
                      t("Code anstatt eines Links", null, "capital") +
                      "::" +
                      t("use_code_for_verification_info") +
                      "//"
                    }
                  />
                }
              </React.Fragment>
            }
          >
            <a>
              <i className="inb-ico fi fi-info"> {t("info", null, "capital")}</i>
            </a>
          </HtmlTooltip>
        </label>
        <FormItem
          type="checkbox"
          value={setting.uses_code_for_verification}
          id={setting.id}
          name="uses_code_for_verification"
          label={t("use code for verification")}
          labelStyle={{ minWidth: "230px" }}
          htmlFor={t("use code for verification")}
          mediumWidth="12"
          smallWidth="12"
          onChangeHandler={onChange}
        />
      </fieldset>
      <fieldset className="fieldBox row" style={{ width: "98%", marginLeft: "10px" }}>
        <label className="inb-form__controlLabel legendLabel">
          <HtmlTooltip
            title={
              <React.Fragment>
                {
                  <ADJUSTMENT_HELP_TEXT
                    content={
                      t("Verifizierung", null, "capital") +
                      "::" +
                      t("verify_info") +
                      "//" +
                      t("Verifizierung per E-Mail Adresse") +
                      "::" +
                      t("verify_info_email") +
                      "//" +
                      t("Verifizierung per Mobilfunknummer") +
                      "::" +
                      t("verify_info_mobile") +
                      "//" +
                      t("Verifizierung per Post") +
                      "::" +
                      t("verify_info_postal")
                    }
                  />
                }
              </React.Fragment>
            }
          >
            <a>
              <i className="inb-ico fi fi-info"> {t("info", null, "capital")}</i>
            </a>
          </HtmlTooltip>
        </label>
        <FormItem
          type="checkbox"
          value={setting.verify_email}
          id={setting.id}
          name="verify_email"
          label={t("verify email")}
          labelStyle={{ minWidth: "230px" }}
          htmlFor={t("verify email")}
          mediumWidth="4"
          smallWidth="12"
          onChangeHandler={onChange}
        />
        <FormItem
          type="checkbox"
          value={setting.verify_mobile_number}
          id={setting.id}
          name="verify_mobile_number"
          label={t("verify mobile number")}
          labelStyle={{ minWidth: "230px" }}
          htmlFor={t("verify mobile number")}
          mediumWidth="4"
          smallWidth="12"
          onChangeHandler={onChange}
        />
        <FormItem
          type="checkbox"
          value={setting.verify_postal}
          id={setting.id}
          name="verify_postal"
          label={t("verify postal")}
          labelStyle={{ minWidth: "230px" }}
          htmlFor={t("verify postal")}
          mediumWidth="4"
          smallWidth="12"
          onChangeHandler={onChange}
        />
      </fieldset>
    </>
  );
};

export default GeneralUserSettings;
